module.exports = __webpack_public_path__ + "img/menu11.e16bb0cb.png";